<template>
  <div class="sidebar">
    <div class="profile">
      <img src="../assets/user.png" alt="" class="user-profile-photo" />
      <p class="user-name">{{ userName }}</p>
      <p class="user-department">{{ userDepartment }}</p>
    </div>
    <div class="courses">
      <p class="courses-offered-text">Your courses this semester:</p>
      <div class="courses-offered">
        <p class="course" v-for="(course, index) in courses" :key="index">
          {{ course }}
        </p>
      </div>
    </div>
    <!--    <p class="help-text">Do you need help?</p> -->
  </div>
</template>

<script>
export default {
  name: "PageSidebar",
  props: {
    msg: String,
    userName: String,
    userDepartment: String,
    courses: [],
  },
};
</script>

<style scoped lang="scss">
.sidebar {
  width: 28.6%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0rem 1.389vw;
  gap: 1.389vw;
  position: fixed;
  border-right: 0.5px solid rgba(0, 0, 0, 0.25);
  position: relative;
  left: 0;
  background-color: #f3f3f3;
  .profile {
    display: flex;
    flex-direction: column;
    gap: 0.926vw;
    img {
      width: 8.681vw;
      height: 8.681vw;
    }
    p.user-name {
      color: #000;
      font-family: "DM Sans";
      font-size: 1.852vw;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: -0.074vw;
    }
    p.user-department {
      color: rgba(0, 0, 0, 0.7);
      font-family: "DM Sans";
      font-size: 0.926vw;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      letter-spacing: -0.037vw;
    }
  }
  .courses {
    display: flex;
    flex-direction: column;
    gap: 0.926vw;
    padding: 1.389vw auto;
    align-items: center;
    p.courses-offered-text {
      color: rgba(0, 0, 0, 0.5);
      font-family: "DM Sans";
      font-size: 0.926vw;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      letter-spacing: -0.037vw;
    }
    .courses-offered {
      display: flex;
      padding: 0rem 1.389vw;
      justify-content: center;
      align-items: flex-start;
      align-content: flex-start;
      gap: 0.926vw;
      align-self: stretch;
      flex-wrap: wrap;
      .course {
        color: rgba(0, 0, 0, 0.7);
        font-family: "DM Sans";
        font-size: 0.926vw;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: -0.037vw;
      }
    }
  }
  p.help-text {
    position: absolute;
    bottom: 0;
    left: 50%;
  }
}
</style>
